export const forecastCountries = {
  countries: [
    {
      countryName: "Austria",
      countryCapitol: "Wiedeń",
      regionLocid: "ATL000001",
      domainURL: "austria.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Bułgaria",
      countryCapitol: "Sofia",
      regionLocid: "BGL000001",
      domainURL: "bulgaria.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Czechy",
      countryCapitol: "Praga",
      regionLocid: "CZL000001",
      domainURL: "czechy.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Francja",
      countryCapitol: "Paryż",
      regionLocid: "FRL000001",
      domainURL: "francja.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Słowacja",
      countryCapitol: "Bratysława",
      regionLocid: "SKL000001",
      domainURL: "slowacja.com.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Słowenia",
      countryCapitol: "Ljubljana",
      regionLocid: "SIL000001",
      domainURL: "slowenia.info.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Włochy",
      countryCapitol: "Rzym",
      regionLocid: "ITL000001",
      domainURL: "wlochy.pl/pogoda-klimat.xml",
    },
  ],
};
